<div class="app-container">
  <header class="app-header" *ngIf="isAuthenticated && !isOnboardingPage">
    <app-logo></app-logo>

    <!-- Team Selector -->
    <div class="team-selector" *ngIf="currentTeam">
      <button class="team-selector-button" (click)="toggleTeamMenu()">
        <span class="team-selector-main">
          <span class="team-selector-avatar">
            <img
              *ngIf="getTeamLogoUrl(currentTeam) as currentTeamLogo; else currentTeamInitial"
              [src]="currentTeamLogo"
              alt="Team logo"
            />
            <ng-template #currentTeamInitial>
              <span>{{ getTeamInitial(currentTeam.name) }}</span>
            </ng-template>
          </span>
          <span class="team-name">{{ currentTeam.name }}</span>
        </span>
        <svg
          class="chevron-icon"
          [class.open]="showTeamMenu"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 6L8 10L12 6"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>

      <div class="team-dropdown" *ngIf="showTeamMenu">
        <div class="team-dropdown-header">Switch Team</div>
        <button
          *ngFor="let team of userTeams"
          class="team-dropdown-item"
          [class.active]="team.id === currentTeam.id"
          (click)="selectTeam(team)"
        >
          <span class="team-dropdown-label">
            <span class="team-selector-avatar team-dropdown-avatar">
              <img
                *ngIf="getTeamLogoUrl(team) as teamLogo; else teamInitial"
                [src]="teamLogo"
                alt="Team logo"
              />
              <ng-template #teamInitial>
                <span>{{ getTeamInitial(team.name) }}</span>
              </ng-template>
            </span>
            <span class="team-dropdown-name">{{ team.name }}</span>
          </span>
          <svg
            *ngIf="team.id === currentTeam.id"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.3332 4L5.99984 11.3333L2.6665 8"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>

    <div class="header-actions">
      <span
        class="header-action-hint"
        *ngIf="currentTeam"
      >
        <button
          class="btn btn-new-season"
          (click)="openCreateSeasonModal()"
        >
          + New Season
        </button>
      </span>
      <span
        class="header-action-hint"
      >
        <button
          (click)="openSessionModal()"
          class="btn btn-new-session"
        >
          + New Session
        </button>
      </span>
      <button
        *ngIf="activeSession && isOnSessionPage"
        (click)="closeSessionView()"
        class="btn btn-close-session-view"
      >
        Back
      </button>
      <a
        class="coffee-support-link"
        href="https://ko-fi.com/nabblsawesome"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Buy me a coffee on Ko-fi"
      >
        <span class="coffee-support-icon" aria-hidden="true">
          <span class="coffee-support-steam coffee-support-steam-left"></span>
          <span class="coffee-support-steam coffee-support-steam-right"></span>
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M5 9H16V14.5C16 17 14 19 11.5 19H9.5C7 19 5 17 5 14.5V9Z" stroke="currentColor" stroke-width="1.8" />
            <path d="M16 11H18C19.1 11 20 11.9 20 13C20 14.1 19.1 15 18 15H16" stroke="currentColor" stroke-width="1.8" />
            <path d="M4 21H18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          </svg>
        </span>
        <span>Buy me a coffee</span>
      </a>

      <div class="auth-section">
        <div
          class="onboarding-progress-pill"
          *ngIf="!currentUser?.onboardingCompleted"
        >
          <span class="onboarding-progress-label">
            Onboarding {{ onboardingProgressCount }}/4
          </span>
          <div class="onboarding-progress-popover">
            <span
              >Create/join team {{ onboardingStepHasTeam ? "✓" : "•" }}</span
            >
            <span
              >Install client
              {{ onboardingStepClientInstalled ? "✓" : "•" }}</span
            >
            <span
              >Validate feed {{ onboardingStepFeedValidated ? "✓" : "•" }}</span
            >
            <span
              >Join first session
              {{ onboardingStepJoinedSession ? "✓" : "•" }}</span
            >
          </div>
        </div>
        <div class="telemetry-status" [class.connected]="telemetryConnected">
          <span class="status-dot"></span>
          <span class="status-text">{{
            telemetryConnected
              ? "Telemetry Connected"
              : "Waiting for Telemetry..."
          }}</span>
        </div>
        <div class="user-menu-container" *ngIf="currentUser">
          <div class="user-info" (click)="toggleUserMenu()">
            <div class="user-avatar">
              <img
                *ngIf="currentUser.avatarUrl; else userAvatarInitial"
                [src]="currentUser.avatarUrl"
                alt="Profile picture"
              />
              <ng-template #userAvatarInitial>
                {{ currentUserDisplayName.charAt(0).toUpperCase() }}
              </ng-template>
            </div>
            <div class="user-details">
              <span class="user-name">{{ currentUserDisplayName }}</span>
              <span class="user-email">{{ currentUser.email }}</span>
            </div>
            <svg
              class="chevron-icon"
              [class.open]="showUserMenu"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 6L8 10L12 6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="user-dropdown" *ngIf="showUserMenu">
            <button
              *ngIf="currentUser?.telemetryClientDownloadClicked"
              class="dropdown-item dropdown-item-download"
              (click)="downloadTelemetryClient(); showUserMenu = false"
            >
              <span>Download Telemetry Client</span>
            </button>
            <div
              *ngIf="currentUser?.telemetryClientDownloadClicked"
              class="dropdown-divider"
            ></div>
            <button class="dropdown-item" (click)="openSettings()">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.9333 10C12.8444 10.2026 12.8185 10.4281 12.8592 10.6464C12.8999 10.8648 13.005 11.0657 13.16 11.2233L13.1933 11.2567C13.3174 11.3807 13.4161 11.5279 13.4838 11.6898C13.5515 11.8518 13.5868 12.0254 13.5868 12.2008C13.5868 12.3762 13.5515 12.5498 13.4838 12.7118C13.4161 12.8738 13.3174 13.021 13.1933 13.145C13.0694 13.2691 12.9221 13.3677 12.7602 13.4355C12.5982 13.5032 12.4246 13.5385 12.2492 13.5385C12.0738 13.5385 11.9003 13.5032 11.7383 13.4355C11.5763 13.3677 11.4291 13.2691 11.305 13.145L11.2717 13.1117C11.114 12.9567 10.9131 12.8516 10.6948 12.8109C10.4764 12.7702 10.251 12.7961 10.0483 12.885C9.85016 12.9699 9.6821 13.1133 9.56589 13.2965C9.44968 13.4797 9.39036 13.6945 9.395 13.9133V14C9.395 14.3536 9.25446 14.6928 9.00441 14.9428C8.75437 15.1929 8.41522 15.3333 8.06167 15.3333C7.70812 15.3333 7.36897 15.1929 7.11892 14.9428C6.86888 14.6928 6.72833 14.3536 6.72833 14V13.9467C6.72833 13.722 6.66394 13.5024 6.54303 13.3149C6.42212 13.1273 6.25005 12.9799 6.04833 12.8908C5.84573 12.802 5.6203 12.776 5.40193 12.8167C5.18357 12.8574 4.98271 12.9625 4.825 13.1175L4.79167 13.1508C4.66757 13.2749 4.52038 13.3736 4.35841 13.4413C4.19644 13.509 4.0229 13.5444 3.8475 13.5444C3.6721 13.5444 3.49856 13.509 3.33659 13.4413C3.17462 13.3736 3.02743 13.2749 2.90333 13.1508C2.77925 13.0267 2.68059 12.8796 2.61287 12.7176C2.54515 12.5556 2.50977 12.3821 2.50977 12.2067C2.50977 12.0313 2.54515 11.8577 2.61287 11.6958C2.68059 11.5338 2.77925 11.3866 2.90333 11.2625L2.93667 11.2292C3.09169 11.0715 3.1968 10.8706 3.23749 10.6523C3.27818 10.4339 3.2523 10.2085 3.16333 10.0058C3.07842 9.80768 2.935 9.63963 2.7518 9.52342C2.5686 9.40721 2.35384 9.34789 2.135 9.35253H2.04833C1.69479 9.35253 1.35564 9.21199 1.10559 8.96194C0.855547 8.7119 0.715 8.37275 0.715 8.0192C0.715 7.66565 0.855547 7.3265 1.10559 7.07645C1.35564 6.82641 1.69479 6.68587 2.04833 6.68587H2.10167C2.32635 6.68587 2.54598 6.62148 2.73356 6.50057C2.92114 6.37966 3.06854 6.20759 3.15767 6.00587C3.24663 5.80326 3.27251 5.57783 3.23182 5.35947C3.19113 5.1411 3.08603 4.94024 2.931 4.78253L2.89767 4.7492C2.77358 4.6251 2.67492 4.47791 2.6072 4.31594C2.53949 4.15397 2.5041 3.98043 2.5041 3.80503C2.5041 3.62963 2.53949 3.45609 2.6072 3.29412C2.67492 3.13215 2.77358 2.98496 2.89767 2.86087C3.02176 2.73678 3.16895 2.63812 3.33092 2.5704C3.49289 2.50269 3.66643 2.4673 3.84183 2.4673C4.01723 2.4673 4.19077 2.50269 4.35274 2.5704C4.51471 2.63812 4.6619 2.73678 4.786 2.86087L4.81933 2.8942C4.97704 3.04922 5.1779 3.15432 5.39627 3.19501C5.61463 3.2357 5.84006 3.20982 6.04267 3.12087H6.04833C6.24649 3.03596 6.41455 2.89254 6.53076 2.70934C6.64697 2.52614 6.70628 2.31138 6.70167 2.09253V2.00587C6.70167 1.65232 6.84221 1.31317 7.09226 1.06312C7.3423 0.813076 7.68145 0.672531 8.035 0.672531C8.38855 0.672531 8.7277 0.813076 8.97774 1.06312C9.22779 1.31317 9.36833 1.65232 9.36833 2.00587V2.05920C9.36295 2.27805 9.42226 2.49281 9.53847 2.67601C9.65468 2.85921 9.82274 3.00263 10.0209 3.08753C10.2235 3.17651 10.4489 3.20239 10.6673 3.16169C10.8857 3.121 11.0865 3.01589 11.2442 2.86087L11.2775 2.8275C11.4016 2.7034 11.5488 2.60474 11.7108 2.53703C11.8728 2.46931 12.0463 2.43392 12.2217 2.43392C12.3971 2.43392 12.5706 2.46931 12.7326 2.53703C12.8946 2.60474 13.0418 2.7034 13.1659 2.8275C13.29 2.95159 13.3886 3.09878 13.4563 3.26075C13.5241 3.42272 13.5594 3.59626 13.5594 3.77166C13.5594 3.94706 13.5241 4.1206 13.4563 4.28257C13.3886 4.44454 13.29 4.59173 13.1659 4.71582L13.1325 4.74916C12.9775 4.90687 12.8724 5.10773 12.8317 5.32609C12.791 5.54446 12.8169 5.76989 12.9058 5.9725V6.00587C12.9907 6.20403 13.1342 6.37208 13.3174 6.48829C13.5006 6.60450 13.7153 6.66382 13.9342 6.65917H14.0208C14.3744 6.65917 14.7135 6.79971 14.9636 7.04976C15.2136 7.2998 15.3542 7.63895 15.3542 7.9925C15.3542 8.34605 15.2136 8.6852 14.9636 8.93525C14.7135 9.18529 14.3744 9.32583 14.0208 9.32583H13.9675C13.7487 9.32121 13.5339 9.38052 13.3507 9.49673C13.1675 9.61294 13.0241 9.781 12.9392 9.97917V10C12.8502 10.2026 12.8243 10.4281 12.865 10.6464C12.9057 10.8648 13.0108 11.0657 13.1658 11.2233L13.1992 11.2567C13.3232 11.3808 13.4219 11.528 13.4896 11.6899C13.5573 11.8519 13.5927 12.0254 13.5927 12.2008C13.5927 12.3762 13.5573 12.5498 13.4896 12.7117C13.4219 12.8737 13.3232 13.0209 13.1992 13.145"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>Settings</span>
              <span class="wip-badge">WIP</span>
            </button>
            <div class="dropdown-divider"></div>
            <button class="dropdown-item" routerLink="/admin/users">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 8C9.65685 8 11 6.65685 11 5C11 3.34315 9.65685 2 8 2C6.34315 2 5 3.34315 5 5C5 6.65685 6.34315 8 8 8Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14 14C14 11.7909 11.3137 10 8 10C4.68629 10 2 11.7909 2 14"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>Admin Panel</span>
            </button>
            <div class="dropdown-divider"></div>
            <button class="dropdown-item" (click)="logout()">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10.6667 11.3333L14 8L10.6667 4.66666"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14 8H6"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>

  <header class="app-header" *ngIf="!isAuthenticated && !isOnboardingPage">
    <app-logo></app-logo>
    <div class="guest-header-actions">
      <a
        class="coffee-support-link"
        href="https://ko-fi.com/nabblsawesome"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Buy me a coffee on Ko-fi"
      >
        <span class="coffee-support-icon" aria-hidden="true">
          <span class="coffee-support-steam coffee-support-steam-left"></span>
          <span class="coffee-support-steam coffee-support-steam-right"></span>
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M5 9H16V14.5C16 17 14 19 11.5 19H9.5C7 19 5 17 5 14.5V9Z" stroke="currentColor" stroke-width="1.8" />
            <path d="M16 11H18C19.1 11 20 11.9 20 13C20 14.1 19.1 15 18 15H16" stroke="currentColor" stroke-width="1.8" />
            <path d="M4 21H18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          </svg>
        </span>
        <span>Buy me a coffee</span>
      </a>
      <a routerLink="/login" class="guest-link">Login</a>
      <a routerLink="/register" class="btn btn-new-session">Create Account</a>
    </div>
  </header>

  <!-- Tier Limit Banner (hidden on session page) -->
  <div
    class="telemetry-download-banner"
    *ngIf="showTelemetryClientDownloadBanner && !isOnboardingPage"
  >
    <div class="telemetry-download-banner-content">
      <div class="telemetry-download-banner-text">
        <strong>Install the Telemetry Client</strong>
        <span
          >Download it once to connect your live iRacing data to
          SpecTrace.</span
        >
        <span
          class="telemetry-download-banner-feedback"
          *ngIf="telemetryDownloadStatus === 'starting'"
        >
          Starting download…
        </span>
        <span
          class="telemetry-download-banner-feedback"
          *ngIf="telemetryDownloadStatus === 'opened'"
        >
          Download opened. If nothing happens, use the direct fallback link
          below.
        </span>
        <span
          class="telemetry-download-banner-feedback telemetry-download-banner-feedback-error"
          *ngIf="telemetryDownloadStatus === 'blocked'"
        >
          Your browser blocked the download popup. Use the direct fallback link
          and installation steps.
        </span>
      </div>
      <div class="telemetry-download-banner-actions">
        <button
          class="telemetry-download-banner-button"
          (click)="downloadTelemetryClient()"
        >
          Download Telemetry Client
        </button>
        <button
          type="button"
          class="telemetry-download-banner-dismiss"
          (click)="dismissTelemetryClientDownloadBanner()"
        >
          Dismiss
        </button>
        <a
          class="telemetry-download-banner-link"
          [href]="telemetryClientFallbackUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          Open fallback download page
        </a>
      </div>
    </div>
    <ol class="telemetry-download-banner-steps">
      <li>Download and run the installer on your iRacing PC.</li>
      <li>Sign in to the telemetry client with your SpecTrace account.</li>
      <li>Start iRacing, then return to SpecTrace and refresh this page.</li>
    </ol>
  </div>

  <!-- Navigation Menu -->
  <nav
    class="main-nav"
    *ngIf="isAuthenticated && !isOnSessionPage && !isOnboardingPage"
  >
    <a routerLink="/sessions" routerLinkActive="active" class="nav-link">
      Sessions
    </a>
    <a
      routerLink="/seasons"
      routerLinkActive="active"
      class="nav-link"
      *ngIf="currentTeam"
    >
      Seasons
    </a>
    <a
      routerLink="/leaderboard"
      routerLinkActive="active"
      class="nav-link"
      *ngIf="currentTeam"
    >
      Team Leaderboard
    </a>
    <a
      routerLink="/best-laps"
      routerLinkActive="active"
      class="nav-link"
      *ngIf="currentTeam"
    >
      Team Best Laps
    </a>
    <a
      [routerLink]="['/teams', currentTeam.id, 'admin']"
      routerLinkActive="active"
      class="nav-link"
      *ngIf="currentTeam"
    >
      Team Admin
    </a>
  </nav>

  <nav
    class="main-nav"
    *ngIf="!isAuthenticated && !isOnSessionPage && !isOnboardingPage"
  >
    <a routerLink="/sessions" routerLinkActive="active" class="nav-link">
      Public Sessions
    </a>
  </nav>

  <!-- Active Session Banner (hidden when viewing session) -->
  <div
    class="active-session-banner"
    *ngIf="isAuthenticated && activeSession && !isOnSessionPage"
  >
    <div class="banner-content">
      <div class="banner-text">
        <span class="session-indicator">●</span>
        <span
          >Active Session: {{ activeSession.name }}
          <small>({{ activeSession.trackName }})</small></span
        >
      </div>
      <a
        [routerLink]="['/session', activeSession.id]"
        routerLinkActive="active"
        class="view-session-link"
      >
        View Session
      </a>
    </div>
  </div>

  <main class="app-main">
    <!-- Authenticated content -->
    <div class="main-content" *ngIf="isAuthenticated">
      <router-outlet></router-outlet>
    </div>

    <!-- Unauthenticated content (login/register) -->
    <div *ngIf="!isAuthenticated">
      <router-outlet></router-outlet>
    </div>
  </main>

  <!-- Create Season Dialog -->
  <div
    class="modal-overlay create-season-overlay"
    *ngIf="showCreateSeasonModal"
    (mousedown)="onSeasonModalMouseDown($event)"
    (click)="onSeasonModalOverlayClick($event)"
  >
    <section
      class="create-season-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="create-season-title"
      aria-describedby="create-season-subtitle"
    >
      <header class="create-season-header">
        <div>
          <h2 id="create-season-title">Create New Season</h2>
          <p id="create-season-subtitle">
            Set up a championship season to group sessions and track standings.
          </p>
        </div>
        <button
          class="create-season-close"
          type="button"
          aria-label="Close create season dialog"
          (click)="closeCreateSeasonModal()"
        >
          &times;
        </button>
      </header>

      <form class="create-season-form" (ngSubmit)="createSeason()">
        <div class="create-season-field">
          <label for="new-season-name">Season name <span>*</span></label>
          <input
            id="new-season-name"
            type="text"
            [(ngModel)]="newSeasonName"
            [ngModelOptions]="{ standalone: true }"
            name="newSeasonName"
            maxlength="80"
            placeholder="e.g. Winter Cup 2026"
            [disabled]="creatingSeason"
            autofocus
          />
        </div>

        <div class="create-season-field">
          <label for="new-season-description">Description</label>
          <textarea
            id="new-season-description"
            [(ngModel)]="newSeasonDesc"
            [ngModelOptions]="{ standalone: true }"
            name="newSeasonDesc"
            maxlength="240"
            placeholder="Optional: share format, goals, or rules."
            rows="4"
            [disabled]="creatingSeason"
          ></textarea>
          <div class="create-season-counter">
            {{ newSeasonDesc.length }}/240
          </div>
        </div>

        <p class="create-season-error" *ngIf="seasonCreationError">
          {{ seasonCreationError }}
        </p>

        <div class="create-season-actions">
          <button
            class="btn btn-season-secondary"
            type="button"
            (click)="closeCreateSeasonModal()"
            [disabled]="creatingSeason"
          >
            Cancel
          </button>
          <button
            class="btn btn-season-primary"
            type="submit"
            [disabled]="isCreateSeasonDisabled"
          >
            {{ creatingSeason ? "Creating..." : "Create Season" }}
          </button>
        </div>
      </form>
    </section>
  </div>

  <!-- Session Modal -->
  <div *ngIf="showSessionModal" class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <h2>New Session</h2>
        <button class="modal-close" (click)="closeSessionModal()">
          &times;
        </button>
      </div>
      <div class="modal-body">
        <app-session-starter
          [forceCreateMode]="true"
          (sessionStarted)="onSessionStarted($event)"
        ></app-session-starter>
      </div>
    </div>
  </div>

  <!-- Settings Modal -->
  <app-settings-modal
    *ngIf="showSettingsModal"
    (close)="closeSettingsModal()"
  ></app-settings-modal>

  <footer class="app-footer" *ngIf="!isOnboardingPage">
    <div class="app-footer-content">
      <p>SpecTrace - Powered by iRacing Data API</p>
      <div class="app-footer-links">
        <a
          href="https://spectrace.app/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy
        </a>
        <a
          href="https://spectrace.app/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms
        </a>
        <a
          href="https://spectrace.app/imprint"
          target="_blank"
          rel="noopener noreferrer"
        >
          Imprint
        </a>
        <a href="mailto:info@spectrace.app"> info&#64;spectrace.app </a>
      </div>
    </div>
  </footer>

  <section
    class="cookie-consent-banner"
    *ngIf="showCookieConsentBanner"
    role="dialog"
    aria-live="polite"
  >
    <div class="cookie-consent-content">
      <p>
        We use essential cookies to run SpecTrace and optional cookies to
        improve the experience. Choose your preference.
      </p>
      <div class="cookie-consent-actions">
        <button
          class="btn btn-cookie-secondary"
          type="button"
          (click)="rejectNonEssentialCookies()"
        >
          Reject non-essential
        </button>
        <button
          class="btn btn-cookie-primary"
          type="button"
          (click)="acceptAllCookies()"
        >
          Accept all
        </button>
      </div>
    </div>
  </section>
</div>
